/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import WebpageEditContext from "components/webpage-selector/context";
import { AddWebpageButton } from "components/webpage-selector/add-webpage-button";
import { WebpageSelectorDisplay } from "components/webpage-selector/display";
import { WebpageSelectDialog } from "components/webpage-selector/dialog";
import { WebpageDeleteDialog } from "components/webpage-selector/dialog-delete";

const WebpageSelector = (props) => {
    
    const {
        idx,
        model,
        // localStateWebpage,
        selectedData,
        AddComponent,
        DisplayComponent,
        filter,
        filterValue,
        webpage,
        onSelectWebpage: onSelectWebpageHandler,
        onWebpageRemoved,
        changeTitle,
        changeDescription,
        defaultTitleDescription,
        defaultImage,
    } = props;
    
    const [webpages, setWebpages] = useState();
    const [original, setOriginal] = useState();
    const [selectedWebpage, setSelectedWebpage] = useState(webpage);
    const [open, setOpen] = React.useState(false);
    const [openRemove, setOpenRemove] = React.useState(false);
    const [hasWebpage, setHasWebpage] = useState();
    const [localState, setLocalState] = useState({
        webpage: { title: "", description: "" },
    });

    const onChange = async () => {
        setOpen(true);
    };
    const onRemove = async () => {
        setOpenRemove(true);
    };
    const onSelectWebpage = (selectWebpage) => {
        setSelectedWebpage(selectWebpage);
        onSelectWebpageHandler(selectWebpage);
        handleClose();
    };
    const handleClose = () => {
        setSelectedWebpage(original);
        setOpen(false);
    };
    const ctx = {
        open,
        setOpen,
        handleClose,
        selectedData,
        webpage,
        hasWebpage,
        onChange,
        onRemove,
        selectedWebpage,
        setSelectedWebpage,
        openRemove,
        setOpenRemove,
        onSelectWebpage,
        onWebpageRemoved,
        model,
        webpages,
        setWebpages,
        defaultImage,
        defaultTitleDescription,
        changeTitle,
        changeDescription,
        localState,
        setLocalState,
    };

    useEffect(() => {
        if (webpage) {
            setOriginal(webpage);
            setSelectedWebpage(webpage);
            setHasWebpage(true);
        }
    }, [webpage]);

    useEffect(() => {
        if (selectedWebpage) {
            setHasWebpage(true);
        }
    }, [selectedWebpage]);

    return (
        <Fragment>
            <WebpageEditContext.Provider value={ctx}>
                
                <WebpageSelectorDisplay
                    idx={idx}
                    AddComponent={AddComponent}
                    DisplayComponent={DisplayComponent}
                />
                
                <WebpageSelectDialog
                    filter={filter}
                    filterValue={filterValue}
                />
                
                <WebpageDeleteDialog
                    deleteType='REMOVE'
                />
                
            </WebpageEditContext.Provider>
        </Fragment>
    );
};

export {
    WebpageSelectorDisplay,
    AddWebpageButton,
    WebpageSelectDialog,
    WebpageSelector
};
